import { useTheme } from 'styled-components';
import { Theme } from '../../Theming';

export interface IconProps {
  color?: string;
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  className?: string;
}

export const useDefaultColor = (
  color?: string,
  key: keyof Theme['colors'] = 'darkestGrey'
) => {
  const { colors } = useTheme();

  return color ?? colors[key];
};
